var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvalaraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 13,
    viewBox: "0 0 59 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99352 9.79221C5.99352 9.79221 5.36557 9.01609 5.00077 8.59771L4.48047 9.83465C5.22204 10.9564 5.71842 11.9205 5.98754 12.3874C6.51381 11.4839 7.7996 8.79174 10.4669 6.28148L10.1738 5.57812C8.43951 6.86964 6.96833 8.52495 5.99352 9.79221Z",
    fill: "#059BD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6272 10.0471C32.6272 10.7687 33.0399 11.1385 33.6917 11.2477V13C31.7302 12.9757 30.6836 12.0117 30.6836 10.1866V0H32.6272V10.0471Z",
    fill: "#FC6600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7248 3.7959C36.2968 3.7959 34.3711 5.82108 34.3711 8.36773C34.3711 10.9144 36.225 12.9396 38.5514 12.9396C39.7355 12.9396 40.6864 12.4787 41.2426 11.8299L41.3443 11.8663V12.7637H43.2879V3.97174H41.3443V4.58414L41.2546 4.62053C40.6864 4.12939 39.885 3.7959 38.7248 3.7959ZM38.97 11.2903C37.5168 11.2903 36.3147 10.0049 36.3147 8.36773C36.3147 6.71241 37.5108 5.44515 38.97 5.44515C39.9269 5.44515 40.7582 5.72407 41.3502 6.18489V9.95028C40.8419 10.9265 39.9389 11.2903 38.97 11.2903Z",
    fill: "#FC6600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9083 12.7819H46.852V6.62752C47.4919 5.95448 48.377 5.58461 49.298 5.59067H49.7166V3.7959H49.4714C48.4966 3.7959 47.5696 4.24459 46.9536 5.00858L46.846 4.9722V3.97174H44.9023V12.7819H44.9083Z",
    fill: "#FC6600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5334 3.7959C22.1054 3.7959 20.1797 5.82108 20.1797 8.36773C20.1797 10.9144 22.0336 12.9396 24.36 12.9396C25.5381 12.9396 26.495 12.4787 27.0512 11.8299L27.1529 11.8663V12.7637H29.0965V3.97174H27.1529V4.58414L27.0691 4.62053C26.495 4.12939 25.6996 3.7959 24.5334 3.7959ZM24.7786 11.2903C23.3194 11.2903 22.1233 10.0049 22.1233 8.36773C22.1233 6.71241 23.3194 5.44515 24.7786 5.44515C25.7355 5.44515 26.5668 5.72407 27.1529 6.18489V9.95028C26.6505 10.9265 25.7475 11.2903 24.7786 11.2903Z",
    fill: "#FC6600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4358 3.7959C52.0077 3.7959 50.082 5.82108 50.082 8.36773C50.082 10.9144 51.936 12.9396 54.2623 12.9396C55.4405 12.9396 56.3974 12.4787 56.9535 11.8299L57.0552 11.8663V12.7637H58.9988V3.97174H57.0552V4.58414L56.9715 4.62053C56.3974 4.12939 55.602 3.7959 54.4358 3.7959ZM54.681 11.2903C53.2218 11.2903 52.0257 10.0049 52.0257 8.36773C52.0257 6.71241 53.2218 5.44515 54.681 5.44515C55.6378 5.44515 56.4691 5.72407 57.0552 6.18489V9.95028C56.5529 10.9265 55.6498 11.2903 54.681 11.2903Z",
    fill: "#FC6600"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87138 12.7577H11.9825L10.1226 8.23438C9.6202 8.78008 9.14177 9.35005 8.69922 9.95033L9.87138 12.7577Z",
    fill: "#FC6600"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2753 3.98438L15.5662 10.4116H15.5482H15.5303H15.5183H15.5064H15.5004H15.4825H15.4585L12.7494 3.98438H10.6562L14.5256 12.7521V12.7582H14.5495H16.4812H16.4991V12.7521L20.3744 3.98438H18.2753Z",
    fill: "#FC6600"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92533 0.472656H5.05944L0 12.7572H2.11109L5.77111 4.00157L5.94454 3.52863H6.04023L6.21366 4.00157L7.29612 6.59672C7.79249 6.09346 8.31279 5.62051 8.85701 5.17182L6.92533 0.472656Z",
    fill: "#FC6600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalaraIcon);
export default __webpack_public_path__ + "static/media/avalara-icon.c3c33c94167b83a61e994ee6dbec2324.svg";
export { ForwardRef as ReactComponent };